function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { useStyle } from "./Page.style";
export var Page = function(param) {
    var tmp = param.as, element = tmp === void 0 ? 'div' : tmp, isRtl = param.isRtl, testID = param.testID, children = param.children;
    var containerStyles = useStyle(isRtl).containerStyles;
    var Element = element;
    return _jsx(Element, _objectSpread({
        css: containerStyles
    }, injectTestId(testID), {
        children: children
    }));
};
